module.exports = __webpack_public_path__ + "static/the-obstacle-is-the-way-2d31ebe5bf554f250ee84afb429c4943.jpg";